/**
 * Combines two observables pairing the elements from the first
 * observable with the corresponding elements from the second (if they exist)
 * indexed by id.
 */
import * as Rx from 'rxjs';
import { map } from 'rxjs/operators';
import { startWithEmptyList } from './startWithEmptyList';
export function combineWithLatestItem(ys$, property) {
    return function (xs$) {
        return Rx.combineLatest(xs$, ys$.pipe(startWithEmptyList())).pipe(map(function (_a) {
            var xs = _a[0], ys = _a[1];
            return xs.map(function (x) { return [x, ys.find(function (y) { return y.id === x[property]; })]; });
        }));
    };
}
